import { render } from "./message.vue?vue&type=template&id=35120cb0&scoped=true&ts=true"
import script from "./message.vue?vue&type=script&lang=ts"
export * from "./message.vue?vue&type=script&lang=ts"

import "./message.vue?vue&type=style&index=0&id=35120cb0&scoped=true&lang=css"
import "./message.vue?vue&type=style&index=1&id=35120cb0&lang=css"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35120cb0"]])

export default __exports__